import React from "react"
import { VictoryPie } from "victory"

import { withSavings } from "./withSavings"
import { Icon } from "../../Icon/Icon"
import { StyledColumn } from "../../Styled/Column"
import { StyledRow } from "../../Styled/Row"
import { StyledRule } from "../../Styled/Rule"
import { P, RichText } from "../../Styled/Text"
import {
  Section,
  Title,
  Graph,
  Graphs,
  SavedDays,
  Subtitle,
  Days,
  Additional,
  Curve,
  Container,
  Svg,
  Packages,
  Package,
  PackageSave,
  PackageBubble,
  PackageSavings,
  PackageSavingsSup,
  IconCircle,
  Footnote,
  Label,
} from "./SavingsStyles"

export const Savings = withSavings(
  ({ charts, days, locales, packages, subtitle, title, visible }): JSX.Element => (
    <Section>
      <Svg>
        <defs>
          <linearGradient id="gradientNavy" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#053F58" />
            <stop offset="100%" stopColor="#004B6F" />
          </linearGradient>
          <linearGradient id="gradientGrey" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#C8C8C8" />
            <stop offset="100%" stopColor="#E1E6E7" />
          </linearGradient>
          <linearGradient id="gradientTeal" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#1B8D93" />
            <stop offset="100%" stopColor="#12D9DD" />
          </linearGradient>
        </defs>
      </Svg>
      <Curve />
      <Container width={`lg`}>
        <Title colour={`navy`} serif as={`h2`}>
          {title}
        </Title>
        <Graphs items={`center`} justify={`center`} gutter withWrap>
          <StyledColumn gutter justify={`center md:end`} width={`md:2/5`}>
            <Graph>
              <VictoryPie {...charts.highest} colorScale={["url(#gradientGrey)", "url(#gradientNavy)"]} />
              <Label visible={visible} colour={`white`}>
                {locales?.additionalPackageHighFees}
              </Label>
              <Label as={`h5`} large visible={visible} serif colour={`navy`}>
                {locales?.additionalPackageService}
              </Label>
            </Graph>
          </StyledColumn>
          <StyledColumn gutter justify={`center`} width={`md:1/5`}>
            <Label as={`h5`} comparison visible={visible} serif colour={`navy`}>
              {locales?.additionalPackageCompare}
            </Label>
          </StyledColumn>
          <StyledColumn gutter justify={`center md:start`} width={`md:2/5`}>
            <Graph>
              <VictoryPie {...charts.lowest} colorScale={["url(#gradientTeal)", "url(#gradientNavy)"]} />
              <Label visible={visible} colour={`white`}>
                {locales?.additionalPackageLowFees}
              </Label>
              <Label as={`h5`} large visible={visible} serif colour={`white`}>
                {locales?.additionalPackageService}
              </Label>
            </Graph>
          </StyledColumn>
        </Graphs>
        <SavedDays>
          <StyledRow items={`center`} justify={`md:center`} withWrap={`<sm`}>
            <Subtitle normal as={`h5`}>
              {subtitle}
            </Subtitle>
            <Days align={`center`} as={`h3`} serif bold colour={`navy`}>
              {days}
            </Days>
            <Additional colour={`navy`} large>
              {locales?.additionalPackageDays}*
            </Additional>
            <Days screen={`sm`} align={`center`} as={`h3`} serif bold colour={`navy`}>
              {days}
            </Days>
            <Additional colour={`navy`} screen={`sm`} normal>
              {locales?.additionalPackageDays}
            </Additional>
          </StyledRow>
        </SavedDays>
        <Packages gutter withWrap>
          {packages?.map(({ id, savings, title }) => (
            <Package key={id} gutter width={`md:1/4`}>
              <StyledRule />
              <PackageSave
                colour={`navy`}
                withSpacing
                dangerouslySetInnerHTML={{ __html: locales?.additionalPackageSavings?.replace(`{title}`, `<strong>${title}</strong>`) }}
              />
              <PackageBubble>
                <IconCircle>
                  <Icon name={`arrowUp`} size={18} />
                </IconCircle>
                <PackageSavings italic>{savings}</PackageSavings>
                <PackageSavingsSup>*</PackageSavingsSup>
              </PackageBubble>
            </Package>
          ))}
        </Packages>
        <Footnote justify={`start`}>
          <P>{`*`}</P>
          <RichText>{locales?.additionalPackageFootnote}</RichText>
        </Footnote>
      </Container>
    </Section>
  )
)

export default Savings
